import { useAPIGetKinerjaHarianActive } from 'api/kinerja/kinerja-harian'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useKinerjaTipe } from 'app/KinerjaShared/hooks/useKinerjaTipe'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

export function useKinerjaHarianActive() {
  const { periodYear, periodNo } = usePeriodContext()
  const { tipe } = useKinerjaTipe()
  const { isKsDefinitif, isGuru, isGpkPegawai } = useRoleContext()

  // KS PLT must not access Kinerja Harian — only KS_DEFINITIF is allowed.
  // Non-KS roles (Guru, GPK, etc.) are unaffected by this check.
  const isAllowed = isGuru || isGpkPegawai || isKsDefinitif

  const { data, isLoading, isSuccess } = useAPIGetKinerjaHarianActive({
    params: {
      skpYear: periodYear,
      skpPeriod: periodNo,
      tipe,
    },
    options: {
      enabled:
        isAllowed && Number.isInteger(periodYear) && Number.isInteger(periodNo),
      useErrorBoundary: false,
    },
  })

  const isActive = isAllowed && data?.data?.active === true
  const isPerencanaanReady = data?.data?.perencanaanState === 'READY'

  return { isActive, isPerencanaanReady, isLoading, isSuccess }
}
